module.exports = __webpack_public_path__ + "images/r-vishnevskii_big-2088da.jpg";